import { Card, CardContent } from '@/components/ui/card';
import type { RetailerSummaryCard } from '../../lib/retailerViewUtils';

interface RetailerSummaryProps {
  summaries: RetailerSummaryCard[];
  onSummarySelect?: (id: RetailerSummaryCard['id']) => void;
}

const toneStyles: Record<RetailerSummaryCard['tone'], string> = {
  neutral: 'border-gray-200',
  positive: 'border-emerald-200 bg-emerald-50/40',
  warning: 'border-amber-200 bg-amber-50/50',
};

export function RetailerSummary({ summaries, onSummarySelect }: RetailerSummaryProps) {
  return (
    <div className={`grid grid-cols-1 gap-2 ${summaries.length > 1 ? 'sm:grid-cols-3' : ''}`}>
      {summaries.map((summary) => {
        const clickable = Boolean(onSummarySelect);
        const content = summaries.length === 1 ? (
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <p className="text-xs font-medium text-gray-500">{summary.title}</p>
            <p className="font-semibold tabular-nums">{summary.value}</p>
            <p className="text-xs text-gray-600">{summary.detail}</p>
          </div>
        ) : (
          <>
            <p className="text-xs font-medium text-gray-500">{summary.title}</p>
            <p className="text-2xl font-semibold mt-1 tabular-nums">{summary.value}</p>
            <p className="text-xs text-gray-600 mt-1 line-clamp-2">{summary.detail}</p>
          </>
        );

        if (!clickable) {
          return (
            <Card key={summary.id} className={toneStyles[summary.tone]}>
              <CardContent className={summaries.length === 1 ? 'px-3 py-2.5' : 'p-3'}>{content}</CardContent>
            </Card>
          );
        }

        return (
          <button
            key={summary.id}
            type="button"
            className="text-left"
            onClick={() => onSummarySelect?.(summary.id)}
          >
            <Card className={`${toneStyles[summary.tone]} transition-colors hover:border-blue-300 hover:bg-blue-50/30`}>
              <CardContent className={summaries.length === 1 ? 'px-3 py-2.5' : 'p-3'}>{content}</CardContent>
            </Card>
          </button>
        );
      })}
    </div>
  );
}
